import { SET_BOT_CONFIG_LIST } from "./constants";
const defaultState = {
   extra_process_type:0,
   host_prefix: "",
   hot_ratio: 0,
   id: 0,
   is_need_from_to: 0,
   is_need_image: 0,
   msg_tag: "",
   prefix_str: "",
   price_begin: 0,
   price_end: "",
   status: 0,
   token_contract_address: "",
   token_contract_name: "",
};
function botReducer(state = defaultState, action) {
   switch (action.type) {
      case SET_BOT_CONFIG_LIST:
         if(action.res===null){
            return defaultState
         }else{
            return action.res
         }
      default:
         return state;
   }
}
export default botReducer;
